<!-- Copyright 2020 Adobe. All rights reserved.
This file is licensed to you under the Apache License, Version 2.0 (the "License");
you may not use this file except in compliance with the License. You may obtain a copy
of the License at http://www.apache.org/licenses/LICENSE-2.0
Unless required by applicable law or agreed to in writing, software distributed under
the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
OF ANY KIND, either express or implied. See the License for the specific language
governing permissions and limitations under the License. -->

import {Layout} from '@react-spectrum/docs';
export default Layout;

import docs from 'docs:@react-stately/tabs';
import {ClassAPI, HeaderInfo, TypeContext, FunctionAPI, TypeLink} from '@react-spectrum/docs';
import packageData from '@react-stately/tabs/package.json';

---
category: Collections
keywords: [tabs, state, collections]
after_version: 3.0.0-rc.0
---

# useTabListState

<p>{docs.exports.useTabListState.description}</p>

<HeaderInfo
  packageData={packageData}
  componentNames={['useTabListState']} />

## API

<FunctionAPI function={docs.exports.useTabListState} links={docs.links} />

## Interface

<ClassAPI links={docs.links} class={docs.links[docs.exports.useTabListState.return.base.id]} />

## Example

See the docs for [useTabList](../react-aria/useTabList.html) in react-aria for an example of `useTabListState`.
